/* eslint-disable */
import r1 from './r1.js'

var r = function () {
  function n() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0
      , t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0;
    return function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, n),
      this.x = e,
      this.y = t,
      this
  }
  return r1(n, [{
    key: "set",
    value: function (e, t) {
      return this.x = e,
        this.y = t,
        this
    }
  }, {
    key: "clone",
    value: function () {
      return new n(this.x, this.y)
    }
  }, {
    key: "copy",
    value: function (e) {
      return this.x = e.x,
        this.y = e.y,
        this
    }
  }, {
    key: "add",
    value: function (e) {
      return this.x += e.x,
        this.y += e.y,
        this
    }
  }, {
    key: "addScalar",
    value: function (e) {
      return this.x += e,
        this.y += e,
        this
    }
  }, {
    key: "sub",
    value: function (e) {
      return this.x -= e.x,
        this.y -= e.y,
        this
    }
  }, {
    key: "subScalar",
    value: function (e) {
      return this.x -= e,
        this.y -= e,
        this
    }
  }, {
    key: "subVectors",
    value: function (e, t) {
      return this.x = e.x - t.x,
        this.y = e.y - t.y,
        this
    }
  }, {
    key: "multiply",
    value: function (e) {
      return this.x *= e.x,
        this.y *= e.y,
        this
    }
  }, {
    key: "multiplyScalar",
    value: function (e) {
      return isFinite(e) ? (this.x *= scalar,
        this.y *= scalar) : (this.x = 0,
          this.y = 0),
        this
    }
  }, {
    key: "divide",
    value: function (e) {
      return this.x /= e.x,
        this.y /= e.y,
        this
    }
  }, {
    key: "divideScalar",
    value: function (e) {
      return this.multiplyScalar(1 / e)
    }
  }, {
    key: "dot",
    value: function (e) {
      return this.x * e.x + this.y * e.y
    }
  }, {
    key: "lengthSq",
    value: function () {
      return this.x * this.x + this.y * this.y
    }
  }, {
    key: "length",
    value: function () {
      return Math.sqrt(this.x * this.x + this.y * this.y)
    }
  }, {
    key: "setLength",
    value: function (e) {
      return this.multiplyScalar(e / this.length())
    }
  }, {
    key: "normalize",
    value: function () {
      return this.divideScalar(this.length())
    }
  }, {
    key: "angle",
    value: function () {
      var e = Math.atan2(this.y, this.x);
      return e < 0 && (e += 2 * Math.PI),
        e
    }
  }, {
    key: "distanceTo",
    value: function (e) {
      return Math.sqrt(this.distanceToSquared(e))
    }
  }, {
    key: "distanceToSquared",
    value: function (e) {
      var t = this.x - e.x
        , n = this.y - e.y;
      return t * t + n * n
    }
  }, {
    key: "lerp",
    value: function (e, t) {
      return this.x += (e.x - this.x) * t,
        this.y += (e.y - this.y) * t,
        this
    }
  }, {
    key: "lerpVectors",
    value: function (e, t, n) {
      return this.subVectors(t, e).multiplyScalar(n).add(e)
    }
  }, {
    key: "equals",
    value: function (e) {
      return e.x === this.x && e.y === this.y
    }
  }, {
    key: "rotateAround",
    value: function (e, t) {
      var n = Math.cos(t)
        , i = Math.sin(t)
        , r = this.x - e.x
        , o = this.y - e.y;
      return this.x = r * n - o * i + e.x,
        this.y = r * i + o * n + e.y,
        this
    }
  }]),
    n
}();
var t = { default: r }

export default t
